@if (isTemplate) {
  <div class="templatePlaceholder">
    <!--  <h1>-->
    <!--    <ng-container [ngSwitch]="context">-->
    <!--      <ng-container *ngSwitchCase="'teacher'"> Nauczyciele</ng-container>-->
  <!--    </ng-container>-->
<!--  </h1>-->
</div>
}
@if (!isTemplate && context === 'teacher' && !(names$ | async)?.length) {
  <ng-container
    class="emptyTeachers"
    >
    @if (wholeConfig$ | async; as config) {
      <div
        (click)="editTeacherRoles()"
        class="empty"
    [ngStyle]="{
      'font-size.px': 18 / scale
    }"
        >
        @if (!editable) {
          <h1>Edytuj aby dodać kadrę</h1>
        }
        @if (editable) {
          <h1 (click)="editTeacherRoles()">
            kliknij aby dodać kadrę
          </h1>
        }
      </div>
    }
  </ng-container>
}
@if ((names$ | async)?.length) {
  <div
    class="children"
  [ngStyle]="{
    'justify-content': (config$ | async)?.addSpine
      ? 'flex-start'
      : $safeNavigationMigration((config$ | async)?.align),
    'margin-left.px': $safeNavigationMigration((config$ | async)?.sideMargin),
    'margin-right.px': $safeNavigationMigration((config$ | async)?.sideMargin),
    width:
      'calc(100% + 2 * ' +
      $safeNavigationMigration((config$ | async)?.childHorizontalMargin) +
      'px - 2 * ' +
      $safeNavigationMigration((config$ | async)?.sideMargin) +
      'px)',
    height: 'calc(100% + 2 * ' + $safeNavigationMigration((config$ | async)?.childVerticalMargin) + 'px)',
    transform:
      'translate(-' +
      $safeNavigationMigration((config$ | async)?.childHorizontalMargin) +
      'px,' +
      '-' +
      $safeNavigationMigration((config$ | async)?.childVerticalMargin) +
      'px)'
  }"
    >
    @if (namesListenerRegistered$ | async) {
      @for (
        name of names$ | async; track trackChild(i,
        name); let i = $index; let c = $count) {
        @switch (name.type) {
          @case ('empty') {
            <div
          [ngClass]="{
            spine: name.isSpine
          }"
              [style.--childWidth]="name.layoutWidth || 1"
          [ngStyle]="{
            width: name.isSpine
              ? $safeNavigationMigration((config$ | async)?.spineSize) + 'px'
              : (itemWidth$ | async),
            'height.%': itemHeight$ | async
          }"
            ></div>
          }
          @case ('placeholder') {
            <div
              class="placeholder"
              [style.--childWidth]="name.placeHolderSize"
          [ngStyle]="{
            width: itemWidth$ | async,

            'height.%': itemHeight$ | async,
            'z-index': c - i
          }"
              >
              <lib-button
            (click)="
              removePlaceholder(
                name.placeholderIndex !== undefined
                  ? name.placeholderIndex
                  : name.index
              )
            "
                >Usuń</lib-button
                >
              </div>
            }
            @case ('child') {
              <div
                mat-button
                class="child"
                [style.--childWidth]="1"
          [ngStyle]="{
            width: itemWidth$ | async,
            'height.%': itemHeight$ | async,
            'padding-left.px': $safeNavigationMigration((config$ | async)?.childHorizontalMargin),
            'padding-right.px': $safeNavigationMigration((config$ | async)?.childHorizontalMargin),
            'padding-top.px': $safeNavigationMigration((config$ | async)?.childVerticalMargin),
            'padding-bottom.px': $safeNavigationMigration((config$ | async)?.childVerticalMargin),

            'z-index': c - i,
            transform:
              'translateX(' +
              $safeNavigationMigration(name.childPositionDistortion?.x) +
              'px) translateY(' +
              $safeNavigationMigration(name.childPositionDistortion?.y) +
              'px) rotate(' +
              name.childTilt +
              'deg)',
            'transform-origin':
              $safeNavigationMigration(name.childOriginTransform?.x) +
              '% ' +
              $safeNavigationMigration(name.childOriginTransform?.y) +
              '%'
          }"
          [ngClass]="{
            isEmpty: name.isEmpty
          }"
                #photoContainerElement
                >
                <div
                  class="border"
                  [matMenuTriggerFor]="menu"
            [ngClass]="{
              isNameOnly: $safeNavigationMigration((config$ | async)?.isNameOnly)
            }"
            [ngStyle]="{
              transform:
                config$ | async | generateSingleChildTransform: name.index,
              'border-width.px':
                config$
                | async
                | getRightElementValue: 'childFrameWidth':name.index:name.row,
              'border-color':
                config$
                | async
                | getRightElementValue: 'childFrameColor':name.index:name.row,
              'gap.px': $safeNavigationMigration((config$ | async)?.childPhotoNameToPhotoGap),
              'box-shadow':
                config$
                | async
                | getRightElementValue: 'childShadow':name.index:name.row,
              'background-color':
                config$
                | async
                | calculateBackgroundForChild: name.index:name.row,
              'border-radius.px':
                config$
                | async
                | getRightElementValue: 'childRadius':name.index:name.row
            }"
                  >
                  @if (
                    config$
                    | async
                    | getConfigFromMainOrFromChild: 'photoAsBackground':name.index
                    ) {
                    <div
                      class="photoAsBackgroundContainer"
              [style.mask]="
                (
                  config$
                  | async
                  | getRightElementValue
                    : 'childPhotoOverlayHasColorOverlay'
                    : name.index
                    : name.row
                  | photoOverlayStyles
                    : (config$
                        | async
                        | getRightElementValue
                          : 'childPhotoOverlayColorOverlay'
                          : name.index
                          : name.row)
                    : ({
                        photoId:
                          config$
                          | async
                          | getRightElementValue
                            : 'childPhotoOverlayFileName'
                            : name.index
                            : name.row
                      }
                        | getImageUrl
                          : projectId + '-assets'
                          : 'photographer'
                          : 'DesignerAsset'
                          : projectId
                          : (isLeadingChild ? 2000 : 600)
                        | async)
                ).mask
              "
              [ngStyle]="{
                'padding-left.px':
                  config$
                  | async
                  | getRightElementValue
                    : 'photoSideMargins'
                    : name.index
                    : name.row,
                'padding-right.px':
                  config$
                  | async
                  | getRightElementValue: 'photoSideMargins':name.index:name.row
              }"
                    >
                    @if (
                      config$
                      | async
                      | getRightElementValue
                      : 'childPhotoOverlayFileName'
                      : name.index
                      : name.row; as overlayImage
                      ) {
                      <img
                        class="photoOverlay"
                [style.transform]="
                  'scale(' +
                  (config$
                    | async
                    | getRightElementValue
                      : 'childPhotoOverlayScale'
                      : name.index
                      : name.row) +
                  ')'
                "
                [style.mask]="
                  (
                    config$
                    | async
                    | getRightElementValue
                      : 'childPhotoOverlayHasColorOverlay'
                      : name.index
                      : name.row
                    | photoOverlayStyles
                      : (config$
                          | async
                          | getRightElementValue
                            : 'childPhotoOverlayColorOverlay'
                            : name.index
                            : name.row)
                      : ({
                          photoId:
                            config$
                            | async
                            | getRightElementValue
                              : 'childPhotoOverlayFileName'
                              : name.index
                              : name.row
                        }
                          | getImageUrl
                            : projectId + '-assets'
                            : 'photographer'
                            : 'DesignerAsset'
                            : projectId
                            : (isLeadingChild ? 2000 : 600)
                          | async)
                  ).mask
                "
                [src]="
                  {
                    photoId: overlayImage
                  }
                    | getImageUrl
                      : projectId + '-assets'
                      : 'photographer'
                      : 'DesignerAsset'
                      : projectId
                      : (isLeadingChild ? 2000 : 600)
                    | async
                "
                    />
                }
                <div
                [ngStyle]="{
                  'border-radius.px':
                    config$
                    | async
                    | getRightElementValue: 'photoRadius':name.index:name.row,
                  'border-width.px':
                    config$
                    | async
                    | getRightElementValue
                      : 'childPhotoFrameWidth'
                      : name.index
                      : name.row,
                  'border-color':
                    config$
                    | async
                    | getRightElementValue
                      : 'childPhotoFrameColor'
                      : name.index
                      : name.row
                }"
                  >
                  <ng-container
                  *ngTemplateOutlet="
                    photo;
                    context: {
                      name: name,
                      allDetails:
                        $safeNavigationMigration(name.photo?.photoId)
                        | tabloFaces
                          : $safeNavigationMigration(name.photo?.groupId)
                          : 1
                          : contextId
                          : $safeNavigationMigration(name?.photo)
                          : photoContainerElement.clientWidth
                          : photoContainerElement.clientHeight
                          : {
                              width: $safeNavigationMigration(name.photo?.width),
                              height: $safeNavigationMigration(name.photo?.height)
                            }
                        | async
                    }
                  "
              ></ng-container>
            </div>
          </div>
        }
        @if (!(config$ | async)?.isNameOnly) {
          <div
            class="photo"
              [ngClass]="{
                circle:
                  config$
                  | async
                  | getConfigFromMainOrFromChild: 'photoAsCircle':name.index,
                square:
                  config$
                  | async
                  | getConfigFromMainOrFromChild: 'photoAsSquare':name.index
              }"
              [ngStyle]="{
                'box-shadow':
                  config$
                  | async
                  | getRightElementValue
                    : 'childPhotoShadow'
                    : name.index
                    : name.row,

                opacity:
                  (config$
                  | async
                  | getConfigFromMainOrFromChild
                    : 'photoAsBackground'
                    : name.index)
                    ? '0'
                    : '1',

                'padding-left.px':
                  config$
                  | async
                  | getRightElementValue
                    : 'photoSideMargins'
                    : name.index
                    : name.row,
                'padding-right.px':
                  config$
                  | async
                  | getRightElementValue: 'photoSideMargins':name.index:name.row
              }"
            #photoContainer
            >
            @if (
              config$
              | async
              | getRightElementValue
              : 'childPhotoOverlayFileName'
              : name.index
              : name.row; as overlayImage
              ) {
              <img
                class="photoOverlay"
                [style.transform]="
                  'scale(' +
                  (config$
                    | async
                    | getRightElementValue
                      : 'childPhotoOverlayScale'
                      : name.index
                      : name.row) +
                  ')'
                "
                [style.mask]="
                  (
                    config$
                    | async
                    | getRightElementValue
                      : 'childPhotoOverlayHasColorOverlay'
                      : name.index
                      : name.row
                    | photoOverlayStyles
                      : (config$
                          | async
                          | getRightElementValue
                            : 'childPhotoOverlayColorOverlay'
                            : name.index
                            : name.row)
                      : ({
                          photoId:
                            config$
                            | async
                            | getRightElementValue
                              : 'childPhotoOverlayFileName'
                              : name.index
                              : name.row
                        }
                          | getImageUrl
                            : projectId + '-assets'
                            : 'photographer'
                            : 'DesignerAsset'
                            : projectId
                            : (isLeadingChild ? 2000 : 600)
                          | async)
                  ).mask
                "
                [style.background-color]="
                  (config$
                  | async
                  | getRightElementValue
                    : 'childPhotoOverlayHasColorOverlay'
                    : name.index
                    : name.row)
                    ? (config$
                      | async
                      | getRightElementValue
                        : 'childPhotoOverlayColorOverlay'
                        : name.index
                        : name.row)
                    : 'transparent'
                "
                [src]="
                  (config$
                  | async
                  | getRightElementValue
                    : 'childPhotoOverlayHasColorOverlay'
                    : name.index
                    : name.row)
                    ? ''
                    : ({
                        photoId: overlayImage
                      }
                      | getImageUrl
                        : projectId + '-assets'
                        : 'photographer'
                        : 'DesignerAsset'
                        : projectId
                        : (isLeadingChild ? 2000 : 600)
                      | async)
                "
            />
        }
        <div
                [ngStyle]="{
                  'border-radius.px':
                    config$
                    | async
                    | getRightElementValue: 'photoRadius':name.index:name.row,
                  'border-width.px':
                    config$
                    | async
                    | getRightElementValue
                      : 'childPhotoFrameWidth'
                      : name.index
                      : name.row,
                  'border-color':
                    config$
                    | async
                    | getRightElementValue
                      : 'childPhotoFrameColor'
                      : name.index
                      : name.row,
                  width:
                    'calc(100% - 2 * ' +
                    (config$
                      | async
                      | getRightElementValue
                        : 'photoSideMargins'
                        : name.index
                        : name.row) +
                    'px)'
                }"
          >
          <ng-container
                  *ngTemplateOutlet="
                    photo;
                    context: {
                      name: name,
                      allDetails:
                        $safeNavigationMigration(name.photo?.photoId)
                        | tabloFaces
                          : $safeNavigationMigration(name.photo?.groupId)
                          : 1
                          : contextId
                          : $safeNavigationMigration(name?.photo)
                          : photoContainer.clientWidth
                          : photoContainer.clientHeight
                          : {
                              width: $safeNavigationMigration(name.photo?.width),
                              height: $safeNavigationMigration(name.photo?.height)
                            }
                        | async
                    }
                  "
      ></ng-container>
    </div>
  </div>
}
@if (
  (config$ | async)?.nameHandling !== 'incognito' &&
  !(config$ | async)?.isPhotoOnly
  ) {
  <div
    class="name"
              [ngStyle]="{
                'gap.px': $safeNavigationMigration((config$ | async)?.childNamesGap),
                'border-color':
                  config$
                  | async
                  | getRightElementValue
                    : 'childNameNameFrameColor'
                    : name.index
                    : name.row,
                'border-width.px':
                  config$
                  | async
                  | getRightElementValue
                    : 'childNameFrameWidth'
                    : name.index
                    : name.row,
                color:
                  config$
                  | async
                  | getRightElementValue
                    : 'childPhotoNameFontColor'
                    : name.index
                    : name.row,
                'font-family':
                  $safeNavigationMigration((
                    config$
                    | async
                    | getRightElementValue: 'font':name.index:name.row
                  )?.fontId) + ', fallback',
                'background-color':
                  config$
                  | async
                  | getRightElementValue
                    : 'childNameBackgroundColor'
                    : name.index
                    : name.row,
                'padding-left.px':
                  config$
                  | async
                  | getRightElementValue
                    : 'childNameSideMargins'
                    : name.index
                    : name.row,
                'padding-right.px':
                  config$
                  | async
                  | getRightElementValue
                    : 'childNameSideMargins'
                    : name.index
                    : name.row,
                'border-radius.px':
                  config$
                  | async
                  | getRightElementValue
                    : 'childNameFrameRadius'
                    : name.index
                    : name.row,
                transform: name | nameTransform: (config$ | async)
              }"
    >
    @if (
      config$
      | async
      | getRightElementValue
      : 'childNameBackgroundFile'
      : name.index
      : name.row; as backgroundImage
      ) {
      <img
                [src]="
                  {
                    photoId: backgroundImage
                  }
                    | getImageUrl
                      : projectId + '-assets'
                      : 'photographer'
                      : 'DesignerAsset'
                      : projectId
                      : (isLeadingChild ? 2000 : 600)
                    | async
                "
      class="nameBackground"
      />
  }
  @switch ((config$ | async)?.nameHandling) {
    @case ('split') {
      <lib-child-name
        [name]="name.firstName"
        [fontSize]="fontSizeFirstName | async"
        context="firstName-{{ context }}"
                    [ngStyle]="{
                      'height.px': $safeNavigationMigration((config$ | async)?.childFirstNameHeight),
                      'letter-spacing':
                        config$
                        | async
                        | getRightElementValue
                          : 'fontLatterSpacing'
                          : name.index
                          : name.row
                          : 'em'
                          : letterSpacingMap,
                      'text-transform':
                        (config$
                        | async
                        | getRightElementValue: 'uppercase':name.index:name.row)
                          ? 'uppercase'
                          : 'none'
                    }"
      ></lib-child-name>
      <lib-child-name
        [name]="name.lastName"
        [fontSize]="fontSizeLastName | async"
                    [ngStyle]="{
                      'height.px': $safeNavigationMigration((config$ | async)?.childLastNameHeight),
                      'letter-spacing':
                        config$
                        | async
                        | getRightElementValue
                          : 'fontLatterSpacing'
                          : name.index
                          : name.row
                          : 'em'
                          : letterSpacingMap,
                      'text-transform':
                        (config$
                        | async
                        | getRightElementValue: 'uppercase':name.index:name.row)
                          ? 'uppercase'
                          : 'none'
                    }"
        context="name-{{ context }}"
      ></lib-child-name>
    }
    @case ('join') {
      <lib-child-name
                    [ngStyle]="{
                      'height.px': $safeNavigationMigration((config$ | async)?.childFirstNameHeight),
                      'letter-spacing':
                        config$
                        | async
                        | getRightElementValue
                          : 'fontLatterSpacing'
                          : name.index
                          : name.row
                          : 'em'
                          : letterSpacingMap,
                      'text-transform':
                        (config$
                        | async
                        | getRightElementValue: 'uppercase':name.index:name.row)
                          ? 'uppercase'
                          : 'none'
                    }"
        [name]="name.firstName + ' ' + name.lastName"
        [fontSize]="fontSizeFirstName | async"
        context="name-{{ context }}"
      ></lib-child-name>
      @if (name.groupRoles?.length > 0) {
        <lib-child-name
          [name]="name.groupRoles.join(', ')"
          [fontSize]="fontSizeLastName | async"
                    [ngStyle]="{
                      'height.px': $safeNavigationMigration((config$ | async)?.childLastNameHeight),
                      'letter-spacing':
                        config$
                        | async
                        | getRightElementValue
                          : 'fontLatterSpacing'
                          : name.index
                          : name.row
                          : 'em'
                          : letterSpacingMap,
                      'text-transform':
                        (config$
                        | async
                        | getRightElementValue: 'uppercase':name.index:name.row)
                          ? 'uppercase'
                          : 'none'
                    }"
          context="roles-{{ context }}"
        ></lib-child-name>
      }
    }
    @case ('firstNameOnly') {
      <lib-child-name
                    [ngStyle]="{
                      'height.px': $safeNavigationMigration((config$ | async)?.childFirstNameHeight),
                      'letter-spacing':
                        config$
                        | async
                        | getRightElementValue
                          : 'fontLatterSpacing'
                          : name.index
                          : name.row
                          : 'em'
                          : letterSpacingMap,
                      'text-transform':
                        (config$
                        | async
                        | getRightElementValue: 'uppercase':name.index:name.row)
                          ? 'uppercase'
                          : 'none'
                    }"
        [name]="name.firstName"
        [fontSize]="fontSizeFirstName | async"
        context="name-{{ context }}"
      ></lib-child-name>
      @if (name.groupRoles?.length > 0) {
        <lib-child-name
          [name]="name.groupRoles.join(', ')"
          [fontSize]="fontSizeLastName | async"
                    [ngStyle]="{
                      'height.px': $safeNavigationMigration((config$ | async)?.childLastNameHeight),
                      'letter-spacing':
                        config$
                        | async
                        | getRightElementValue
                          : 'fontLatterSpacing'
                          : name.index
                          : name.row
                          : 'em'
                          : letterSpacingMap,
                      'text-transform':
                        (config$
                        | async
                        | getRightElementValue: 'uppercase':name.index:name.row)
                          ? 'uppercase'
                          : 'none'
                    }"
          context="roles-{{ context }}"
        ></lib-child-name>
      }
    }
  }
</div>
}
</div>
<mat-menu #menu="matMenu">
  <button
    mat-menu-item
    (click)="addPlaceHolder(name.sourceIndex || name.index, 1)"
    >
    Dodaj margines pełny
  </button>
  <button
    mat-menu-item
    (click)="addPlaceHolder(name.sourceIndex || name.index, 0.5)"
    >
    Dodaj margines połowkowy
  </button>
  @if (!isTemplate && context !== 'teacher') {
    <button
      mat-menu-item
      (click)="editCrop.next(name)"
      >
      Kadruj
    </button>
  }
  <button mat-menu-item (click)="editCustomIndex.emit(name.index)">
    Indywidualne ustawienia
  </button>
  @if (
    context === 'teacher' &&
    !name.photo?.photoId &&
    !isTemplate &&
    !(faceMatch$ | async)[name.tabloMemberId]
    ) {
    <button
      mat-menu-item
      (click)="editTeachers()"
      >
      Wgraj zdjęcie</button
      >
      }@if (context === 'teacher') {
      <button
        mat-menu-item
        (click)="editTeachers()"
        >
        Zarządzaj kadrą
      </button>
    }
    @if (context === 'teacher') {
      <button
        mat-menu-item
        (click)="editTeacherRoles()"
        >
        Zarządzaj rolami w klasie
      </button>
    }
  </mat-menu>
</div>
}
}
}
}
</div>
}
<ng-template #photo let-all="allDetails" let-name="name">
  @if (
    {
    faceMatch: (faceMatch$ | async) || {},
    maximizePhoto: (maximizePhoto$ | async) || false
    }; as photoState
    ) {
    @if (
      {
      memberDetails: photoState.faceMatch[name.tabloMemberId],
      renderConfig:
      name.photo
      | groupMemberPhotoRenderConfig
      : $safeNavigationMigration(all?.tabloSquare)
      : photoState.faceMatch[name.tabloMemberId]
      : photoState.maximizePhoto
      }; as renderState
      ) {
      <div
        class="photo-container"
        [ngStyle]="{
          transform: renderState.renderConfig.containerTransform
        }"
        [ngClass]="{
          hasCover: renderState.memberDetails || context === 'teacher'
        }"
        >
        @if (renderState.memberDetails; as memberDetails) {
          <div
            class="coverContainer"
            >
            <lib-cover
              [scale]="renderState.renderConfig.scale * scale"
              [imageSize]="{ w: memberDetails.width, h: memberDetails.height }"
              [point]="renderState.renderConfig.point"
              [fitMode]="renderState.renderConfig.fitMode"
              [title]="memberDetails | json"
              [rotation]="renderState.renderConfig.rotation"
            [style.transform]="
              'scale(' + renderState.renderConfig.scale + ')'
            "
              (loaded)="imageLoaded(name)"
            [url]="
              {
                photoId: $safeNavigationMigration(memberDetails?.photoId)
              }
                | getImageUrl
                  : $safeNavigationMigration(memberDetails?.groupId)
                  : 'photographerDesigner'
                  : imagesContext
                  : projectId
                  : (isLeadingChild
                      ? 3000 * renderState.renderConfig.requestedImageScale
                      : 1000 * renderState.renderConfig.requestedImageScale)
                | async
            "
            >
          </lib-cover>
        </div>
      } @else {
        <lib-image-loader
          [disableLoader]="true"
            [url]="
              {
                photoId: $safeNavigationMigration(name.photo?.photoId)
              }
                | getImageUrl
                  : $safeNavigationMigration(name.photo?.groupId)
                  : 'photographerDesigner'
                  : imagesContext
                  : projectId
                  : (isLeadingChild ? 3000 * scale : 1000 * scale)
                | async
            "
        (imageLoaded)="imageLoaded(name)"
        [isCover]="true"
      ></lib-image-loader>
    }
  </div>
}
}
@if (
  !name.photo?.photoId &&
  !isTemplate &&
  !(faceMatch$ | async)[name.tabloMemberId]
  ) {
  <div
    class="empty"
    >
    <svg
      width="400"
      height="400"
      viewBox="0 0 400 400"
      xmlns="http://www.w3.org/2000/svg"
      >
      <text
        x="50%"
        y="40%"
        dominant-baseline="middle"
        text-anchor="middle"
        font-size="40px"
        fill="#000000"
        >
        {{ editable ? 'Kliknij aby' : 'Edytuj grupę' }}
      </text>
      <text
        x="50%"
        y="60%"
        dominant-baseline="middle"
        text-anchor="middle"
        font-size="40px"
        fill="#000000"
        >
        {{ editable ? 'dodać zdjęcie' : 'aby dodać zdjęcie' }}
      </text>
    </svg>
  </div>
}
@if (isTemplate) {
  <div class="empty">
    <svg
      width="400"
      height="400"
      viewBox="0 0 400 400"
      xmlns="http://www.w3.org/2000/svg"
      >
      <text
        x="50%"
        y="40%"
        dominant-baseline="middle"
        text-anchor="middle"
        font-size="40px"
        fill="#000000"
        >
        Tutaj będzie
      </text>
      <text
        x="50%"
        y="60%"
        dominant-baseline="middle"
        text-anchor="middle"
        font-size="40px"
        fill="#000000"
        >
        zdjęcie
      </text>
    </svg>
  </div>
}
@if ($safeNavigationMigration(name.photo?.photoId) | unRetouchedFiles: (sourceGroups$ | async)) {
  <div
    class="unretouched"
    >
    <mat-icon class="unretouched" matTooltip="Zdjęcie nieobrobione"
      >brush
    </mat-icon>
  </div>
}
</ng-template>
